module.exports = __webpack_public_path__ + "img/suppression.562cb9d4.png";